import i18next from 'i18next'
import * as React from 'react'
import { getClassName } from '../../authentication/auth_widget/utils'
import { authOptions } from '../../site/root/rootWidget'

export const SubscriptionUpgradeFlowIntroduction = () => (
    <header
        className={getClassName(
        authOptions,
        'headerClassName',
        'mb-4'
        )}
    >
        <h1
        className={getClassName(
            authOptions,
            'titleClassName',
            'mb-4'
        )}
        >
        {i18next.t('subscription:TrialToProTitle')}
        </h1>
        <p
        className={getClassName(
            authOptions,
            'introClassName',
            'lead'
        )}
        >
        {i18next.t('subscription:TrialToProIntro')}
        </p>
        <ul
        className={
            getClassName(
            authOptions,
            'introClassName',
            'lead'
            ) + ' list--hexagon'
        }
        >
        <li className="list__item">
            <p className="list__text">
            {i18next.t(
                'paywall:paywallRegisterListPrimary'
            )}
            </p>
        </li>
        <li className="list__item">
            <p className="list__text">
            {i18next.t(
                'paywall:paywallRegisterListSecondary'
            )}
            </p>
        </li>
        <li className="list__item">
            <p className="list__text">
            {i18next.t(
                'paywall:paywallRegisterListTertiary'
            )}
            </p>
        </li>
        </ul>
    </header>
)